import { InjectionToken } from '@angular/core';
import { ISessionIdleConfig } from 'app/session-idle/interfaces/session-idle-config.interface';

export const SESSION_IDLE_CONFIG = new InjectionToken<ISessionIdleConfig>('SESSION_IDLE_CONFIG');
